import classNames from 'classnames'
import {ChevronRightIcon, FilterIcon} from 'components'
import {noOperation} from 'definitions/constant'
import {FC, MouseEvent as ReactMouseEvent, RefObject} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {setSortAscending} from '../analyticsDetailAction'
import {
  selectPolicyTypeFilter,
  selectSortAscendingState,
} from '../analyticsDetailSelector'
interface DetailColumnElementProps {
  column: string
  showTypeFilters?: boolean
  setShowTypeFilters?: React.Dispatch<React.SetStateAction<boolean>>
  typeFilterRef?: RefObject<HTMLButtonElement>
}
const DetailColumnElement: FC<DetailColumnElementProps> = ({
  column,
  showTypeFilters,
  setShowTypeFilters,
  typeFilterRef,
}) => {
  let element = null
  const dispatch = useDispatch()
  const sortAscendingState = useSelector(selectSortAscendingState)

  const onTimeColumnClick = (): void => {
    dispatch(setSortAscending(!sortAscendingState))
  }

  switch (column.toLowerCase()) {
    case 'type':
      element = (
        <TypeColumnElement
          column={column}
          showTypeFilters={showTypeFilters}
          setShowTypeFilters={setShowTypeFilters}
          typeFilterRef={typeFilterRef}
        />
      )
      break

    case 'time':
      element = (
        <div
          data-cy={`${column.toLowerCase()}`}
          className="flex items-center"
          onClick={onTimeColumnClick}
        >
          <span>{column}</span>
          <button
            className="ml-2"
            data-cy="analytics-detail-sort-button"
            onClick={noOperation}
          >
            <ChevronRightIcon
              classes={classNames('transform', {
                'rotate-90': !sortAscendingState,
                'rotate-270': sortAscendingState,
              })}
            />
          </button>
        </div>
      )
      break

    default:
      element = <span data-cy={`${column.toLowerCase()}`}>{column}</span>
      break
  }
  return element
}

const TypeColumnElement: FC<DetailColumnElementProps> = ({
  column,
  showTypeFilters = false,
  setShowTypeFilters = noOperation,
  typeFilterRef,
}) => {
  const policyTypeCurrentFilter = useSelector(selectPolicyTypeFilter)

  const onTypeFilterLabelClick = (e: ReactMouseEvent<HTMLDivElement>): void => {
    e.stopPropagation()
    setShowTypeFilters(!showTypeFilters)
  }

  return (
    <div
      data-cy={`${column.toLowerCase()}`}
      className="flex items-center"
      onClick={onTypeFilterLabelClick}
    >
      <span
        className={classNames('cursor-pointer', {
          'text-dope-cyan-200': policyTypeCurrentFilter?.length < 3,
        })}
      >
        {column}
      </span>
      <div className="relative ml-1">
        <div className="flex items-center">
          <button
            data-cy="policy-type-filter-button"
            className={classNames({
              'bg-gray-800': showTypeFilters,
            })}
            onClick={e => {
              e.stopPropagation() // don't close via wrapper
              setShowTypeFilters(p => !p) // functional form avoids stale state
            }}
            ref={typeFilterRef}
          >
            <FilterIcon />
          </button>
        </div>
      </div>
    </div>
  )
}

export default DetailColumnElement
